<template>
  <div class="container p-6 has-text-centered has-background-white">
    <div class="image" style="width:300px;margin: 0 auto">
      <img src="/images/TC wired for Gant Travel.png" />
      <img src="/images/SVGs/Plane_with_Clouds.svg" alt="Book Travel with Trip Circuit">
    </div>

    <div style="max-width:600px;margin: 0 auto">
    <p class="is-size-4 mb-2 has-text-weight-bold">Verify your Email Address</p>
    <p class="is-size-6 mb-4">A verification email has been sent to your email address. To complete your registration, please click on the link in your email. </p>
    </div>
    
   
  </div>
</template>

<script>
export default {
  name: "CheckEmail",
  props: {},
  methods: {},
};
</script>

<style scoped>
.image {
  padding: 15px;
  padding-right: 20px;
}</style>
